import "unfetch/polyfill";

export default function findMomentsForEventId(apiUrl, apiKey, id) {
  return new Promise(function(resolve, reject) {
    fetch(apiUrl + "moment/for_event/" + id + "?apiKey=" + apiKey)
      .then(r => r.json())
      .then(data => {
        resolve(data);
      })
      .catch(reason => {
        reject(reason);
      });
  });
}
